import *
    as React from 'react';
import { RouteComponentProps, useHistory, useLocation } from 'react-router';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, FormGroup, Input, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row, Spinner, Table } from 'reactstrap';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel } from '../Misc/SawinComponents';
import { useEffect, useState } from 'react';
import '../../../node_modules/cleave.js/dist/addons/cleave-phone.us'
import * as AccessRequestMdl from '../../models/AccessRequestModel';
import { APIContainer, LogTypes, sawinFunc } from '../../store/sawinLib';
import * as myCfg from '../../AppConfig';
import { SessionModel } from '../../models/SessionModel';
import * as UserStore from '../../store/User';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
const Cleave = require('../../../node_modules/cleave.js/react');
//type MyProps =
//    { SessionState: SessionMdl.SessionModel, FeedbackState: CustomerFeedbackMdls.CustomerFeedbackModel } & typeof CustomerFeedbackStore.actionCreators;

type LogInProps =
    UserStore.UserState &
    SessionModel &
    typeof UserStore.actionCreators

const AccessRequest: React.FunctionComponent<LogInProps> = (props: LogInProps) => {

    const historyHook = useHistory();

    //useEffect(() => {
    //    if (props.FeedbackState.success == 'Y') {
    //        historyHook.replace('/Feedback');
    //        props.resetState();
    //    }
    //    if (props.FeedbackState.error) {
    //        alert(props.FeedbackState.error);
    //    }
    //}, [props]);

    const [AccessRequestLocal, updateAccessRequestInfo] = useState<AccessRequestMdl.AccessRequestModel>({ ...AccessRequestMdl.initialState });

    const [Loading, updateLoading] = useState<boolean>(false);

    const [EmailSent, updateEmailSend] = useState<boolean>(false);

    const SubmitEvent = (e: React.FormEvent) => {
        e.preventDefault();
        updateLoading(true);
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/Proxy/requestAccess',
            {
                method: 'POST',
                body: JSON.stringify(AccessRequestLocal),
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {
                updateLoading(false);
                if (container.success) {
                    const data: AccessRequestMdl.AccessRequestModel = container.data;
                    //Do something with response
                    updateEmailSend(true);
                    //alert("Success");
                } else {
                    alert(container.errorInfo.message);
                }
            })
            .catch(function (err: Error) {
                updateLoading(false);
                alert(err.message);
            });
    }    

    const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
        e.preventDefault();
        var valueChanged = { [e.target.id]: e.target.value };
        updateAccessRequestInfo({ ...AccessRequestLocal, ...valueChanged });
    }

    const handleCleveChange = (e: any) => {
        e.preventDefault();
        var valueChanged = { [e.target.id]: e.target.rawValue };
        updateAccessRequestInfo({ ...AccessRequestLocal, ...valueChanged });

    }

    function handleRequired(msg: string, e: React.FormEvent<HTMLInputElement>)
    {
       
        var myElement = e.currentTarget;
        myElement.setCustomValidity(msg);
    }

    const handleClear = (e: React.FormEvent<HTMLInputElement>) => {
        var myElement = e.currentTarget;
        myElement.setCustomValidity("");
    }

    const RequestBtn = () => {
        if (!Loading) {
            return (<><input type="submit" value="Request Access" className="btn btn-success" id="RequestBtn" name="RequestBtn" />
                <input type="button" onClick={cancelScreen} value="Cancel" className="btn btn-danger" id="CancelBtn" name="CancelBtn" /></>
            );
        } else {
            return (<span>Loading<Spinner size="sm" color="primary" /></span>);
        }
    }

    const cancelScreen = () => {
        props.requestAccess(false);
    }

    if (EmailSent) {
        return (
            <Container> <div className="logInPositionDiv">Your request has been successfully submitted and is being processed. Someone wil get back with your shortly.</div></Container>);
    } else {
        return (
            <Container fluid={true}>
                {
                    <Card>
                        <CardHeader>
                            Portal Access Form
                        </CardHeader>
                        <CardBody>
                            <form onSubmit={SubmitEvent}>
                                {/*<Row>*/}
                                {/*    <Col xs={12}>*/}
                                {/*        <br />*/}
                                {/*        <RequestBtn />*/}
                                {/*    </Col>*/}
                                {/*</Row>*/}
                                <Row>
                                    <Col xs={12}>
                                        <SaLabel Text={"First Name"} />
                                        <input type="text" required onInvalid={(e)=>handleRequired("First Name is required",e)} onInput={handleClear} onChange={handleChange} className="form-control" key="firstName" id="firstName" name="firstName" value={AccessRequestLocal.firstName} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <SaLabel Text={"Last Name"} />
                                        <input type="text" required onInvalid={(e) => handleRequired("Last Name is required", e)} onInput={handleClear}  onChange={handleChange} className="form-control" key="lastName" id="lastName" name="lastName" value={AccessRequestLocal.lastName} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <SaLabel Text={"Address"} />
                                        <input type="text" required onInvalid={(e) => handleRequired("Address is required", e)} onInput={handleClear} onChange={handleChange} className="form-control" key="address" id="address" name="address" value={AccessRequestLocal.address} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <SaLabel Text={"City"} />
                                        <input type="text" required onInvalid={(e) => handleRequired("City is required", e)} onInput={handleClear} onChange={handleChange} className="form-control" key="city" id="city" name="city" value={AccessRequestLocal.city} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <SaLabel Text={"State"} />
                                        <input type="text" onChange={handleChange} className="form-control" key="state" id="state" name="state" value={AccessRequestLocal.state} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <SaLabel Text={"Home/Work Phone"} />
                                        <Cleave
                                            options={{
                                                uppercase: true,
                                                //delimiters: [' ', ' '],
                                                blocks: [3, 3, 4],
                                                numericOnly: true
                                            }} className="form-control"
                                            onChange={handleCleveChange}
                                            key="homePhone" id="homePhone" name="homePhone"
                                            value={AccessRequestLocal.homePhone}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <SaLabel Text={"Cell Phone"} />
                                        <Cleave
                                            required
                                            onInvalid={(e: React.FormEvent<HTMLInputElement>) => handleRequired("Cell Phone is required", e)} onInput={handleClear}
                                            options={{
                                                uppercase: true,
                                                //delimiters: [' ', ' '],
                                                blocks: [3, 3, 4],
                                                numericOnly: true
                                            }} className="form-control"
                                            onChange={handleCleveChange}
                                            key="cellPhone" id="cellPhone" name="cellPhone"
                                            value={AccessRequestLocal.cellPhone}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        <SaLabel Text={"Email"} />
                                        <input type="text" required onInvalid={(e) => handleRequired("Email is required", e)} onInput={handleClear} onChange={handleChange} className="form-control" key="email" id="email" name="email" value={AccessRequestLocal.email} />
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={12}>
                                        <br />
                                        <RequestBtn />         </Col>
                                </Row>
                            </form>
                        </CardBody>
                    </Card>
                }
            </Container>
        );
    }

}

export default connect((state: ApplicationState) => ({ ...state.user, ...state.sessionState }), UserStore.actionCreators)(AccessRequest as any);